import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useNotify } from "../../../context/NotificationContext";
import { useCommon } from "../../../context/CommonContext";
import spotlightService from "../../../services/spotlightService";
import SpotlightForm from "./SpotlightForm";

const EditSpotlight = () => {
  const navigate = useNavigate();
  const { spotlight_id } = useParams();
  const notify = useNotify();
  const { setPageTitle } = useCommon();

  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(null);
  const [initialImageSets, setInitialImageSets] = useState([]);

  useEffect(() => {
    setPageTitle("Edit Spotlight");

    const load = async () => {
      if (!spotlight_id) return;
      try {
        setLoading(true);
        const response = await spotlightService.getSpotlightById(spotlight_id);
        const row = response?.data?.data?.data || response?.data?.data;

        if (!response?.data?.status || !row) {
          notify.error({
            message: response?.data?.message || "Spotlight not found",
          });
          navigate("/spotlights");
          return;
        }

        setInitialValues({
          spotlight_title: row.spotlight_title || "",
          spotlight_name: row.spotlight_name || "",
          spotlight_is_active: row.spotlight_is_active || "Y",
        });

        // The API returns the sets it stored, keyed by language. Nulls become
        // "" so the upload control treats them as empty rather than as a value.
        setInitialImageSets(
          (Array.isArray(row.images) ? row.images : []).map((set) => ({
            lang_id: set.lang_id ?? null,
            circle_image: set.circle_image || "",
            vertical_card_image: set.vertical_card_image || "",
          }))
        );
      } catch (error) {
        console.error("Error loading spotlight:", error);
        notify.error({
          message: error?.data?.message || "Failed to load spotlight",
        });
        navigate("/spotlights");
      } finally {
        setLoading(false);
      }
    };

    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [spotlight_id]);

  const handleSubmit = async (payload) => {
    try {
      const response = await spotlightService.updateSpotlight(
        spotlight_id,
        payload
      );

      if (response?.data?.status) {
        notify.success({
          message: response.data.message || "Spotlight updated successfully",
        });
        navigate("/spotlights");
      } else {
        notify.error({
          message: response?.data?.message || "Failed to update spotlight",
        });
      }
    } catch (error) {
      console.error("Error updating spotlight:", error);
      notify.error({
        message: error?.data?.message || "Error updating spotlight",
      });
    }
  };

  return (
    <SpotlightForm
      mode="edit"
      loading={loading}
      initialValues={initialValues}
      initialImageSets={initialImageSets}
      onSubmit={handleSubmit}
    />
  );
};

export default EditSpotlight;
